import billing from "./billing";
import studio from "./studio";
import addOns from "./addons";
import builder from "./builder/builder";
import extensions from "./extensions";
import adminPages from "./customAdminPages";
import variation from "./variation";
import defaultTemplates from "./defaultTemplates";
import portfolioMgmtFile from "./portfoliomgmt";
import modules from "./modules";
import projectFile from "./project";
import issueTracker from "./issueTracker";
import getNotify from "./getNotification";
import logsForPagesRoles from "./logsForPagesRoles";
import baseAdminCategory from "./baseAdminCategory";
import events from "./events";

const repositories = {
  billing,
  studio,
  addOns,
  builder,
  extensions,
  adminPages,
  variation,
  defaultTemplates,
  portfolioMgmtFile,
  modules,
  projectFile,
  issueTracker,
  getNotify,
  logsForPagesRoles,
  baseAdminCategory,
  events,
};

export const RepositoryFactory = {
  get: (name) => repositories[name],
};
